/**
 * Custom hooks for body measurements and progress photos (Epic 4)
 */
import useSWR from "swr";
import { fetcher } from "../lib/api";

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook for client's own measurements
 */
export function useMyMeasurements() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/measurements/body",
    fetcher
  );

  return {
    measurements: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Hook for admin viewing a client's measurements
 */
export function useClientMeasurements(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/measurements/admin/${clientId}/body` : null,
    fetcher
  );

  return {
    measurements: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Create a body measurement
 */
export async function createMeasurement(data) {
  return fetcher("/api/measurements/body", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

/**
 * Delete a body measurement
 */
export async function deleteMeasurement(id) {
  const token = localStorage.getItem("access_token");
  const response = await fetch(`${API_URL}/api/measurements/body/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || "Erreur de suppression");
  }
}

/**
 * Hook for client's own progress photos
 */
export function useMyPhotos() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/measurements/photos",
    fetcher
  );

  return {
    photos: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Hook for admin viewing a client's progress photos
 */
export function useClientPhotos(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/measurements/admin/${clientId}/photos` : null,
    fetcher
  );

  return {
    photos: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Upload a progress photo (multipart form)
 */
export async function uploadProgressPhoto(file, photoType, takenAt, notes) {
  const token = localStorage.getItem("access_token");
  const formData = new FormData();
  formData.append("file", file);
  formData.append("photo_type", photoType);
  formData.append("taken_at", takenAt);
  if (notes) formData.append("notes", notes);

  const response = await fetch(`${API_URL}/api/measurements/photos`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || "Erreur d'upload");
  }

  return response.json();
}

/**
 * Delete a progress photo
 */
export async function deleteProgressPhoto(id) {
  const token = localStorage.getItem("access_token");
  const response = await fetch(`${API_URL}/api/measurements/photos/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || "Erreur de suppression");
  }
}
